var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlChart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7893",
    "data-name": "Group 7893",
    transform: "translate(-1083 -224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5221",
    "data-name": "Rectangle 5221",
    transform: "translate(1083 224)",
    fill: "#fff",
    stroke: "#e4e4e4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2387",
    "data-name": "Line 2387",
    x2: 16,
    transform: "translate(1091 240) rotate(-90)",
    fill: "none",
    stroke: "#ea4335",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlChart1);
export default __webpack_public_path__ + "static/media/ControlChart1.7b3c60dcc11a13c151869cc380f85f3d.svg";
export { ForwardRef as ReactComponent };